import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Filter,
  Sliders,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { Table, Checkbox, DatePicker } from "antd";
import { setheadertoggle } from "../../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import { getpayablereport } from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import { renderTooltip } from "../../../redux/helper";
import dayjs from "dayjs";
import {
  exportreportPDF,
  exportreportExcel,
  printreportReport,
} from "../../../core/utils/MainReportUtils";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import axios from "axios";

const base_path = window.APP_CONFIG?.BASE_URL;

const PayableReport = () => {
  const [asOfDate, setAsOfDate] = useState(dayjs());
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [selectedAgeingPeriod, setSelectedAgeingPeriod] = useState({ value: "All", label: "All" });
  const [selectedCreditPeriod, setSelectedCreditPeriod] = useState({ value: "All", label: "All" });
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [totalcount, setTotalcount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [selectedColumns, setSelectedColumns] = useState();

  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const tableRef = useRef(null);

  const ageingOptions = [
    { value: "All", label: "All" },
    { value: "Above120", label: "Above 120 Days" },
    { value: "90-120", label: "90 - 120 Days" },
    { value: "60-90", label: "60 - 90 Days" },
    { value: "30-60", label: "30 - 60 Days" },
    { value: "0-30", label: "0 - 30 Days" },
  ];

  const creditPeriodOptions = [
    { value: "All", label: "All" },
    { value: "Above", label: "Above Credit Period" },
    { value: "Within", label: "Within Credit Period" },
  ];

  useEffect(() => {
    axios.get(`${base_path}/Api/Supplier/GetAll`).then((res) => {
      const options = [{ value: null, label: "All Vendors" }];
      res.data.forEach((s) => options.push({ value: s.guid, label: s.name }));
      setSupplierOptions(options);
    });
  }, []);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const DatatablePagingParameters = new DatatablePagingParameter();
      DatatablePagingParameters.PageNumber = 1;
      DatatablePagingParameters.PageSize = -1;

      const Filters = new Filterclass();
      Filters.Branch = branch;
      Filters.AsOfDate = dayjs(asOfDate).format("YYYY-MM-DD");
      Filters.SupplierGuid = selectedSupplier?.value ?? null;
      Filters.AgeingPeriod = selectedAgeingPeriod?.value ?? "All";
      Filters.CreditPeriodFilter = selectedCreditPeriod?.value ?? "All";

      const response = await getpayablereport({ DatatablePagingParameters, Filters });
      const data = response?.data?.payableReportDetails ?? [];
      setReportData(data);
      setTotalcount(data.length);
    } catch (error) {
      console.error("Error fetching Payable Report:", error?.response?.data?.Message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, [branch]);

  const handleReset = () => {
    setAsOfDate(dayjs());
    setSelectedSupplier(null);
    setSelectedAgeingPeriod({ value: "All", label: "All" });
    setSelectedCreditPeriod({ value: "All", label: "All" });
    setSearchText("");
  };

  const menuItems = [
    { value: "1", label: "Sl.No", checked: true },
    { value: "2", label: "Date", checked: true },
    { value: "3", label: "Vendor", checked: true },
    { value: "4", label: "Bill No", checked: true },
    { value: "5", label: "Bill Amount", checked: true },
    { value: "6", label: "Paid Amount", checked: true },
    { value: "7", label: "Balance", checked: true },
    { value: "8", label: "Ageing (Days)", checked: true },
    { value: "9", label: "Credit Period (Days)", checked: true },
  ];

  const columns = [
    {
      title: "Sl No",
      key: "1",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Date",
      key: "2",
      dataIndex: "date",
      render: (text) =>
        new Date(text).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
    },
    { title: "Vendor", key: "3", dataIndex: "vendorName" },
    { title: "Bill No", key: "4", dataIndex: "billNo" },
    {
      title: "Bill Amount",
      key: "5",
      dataIndex: "billAmount",
      render: (text) => <span>{text?.toFixed(2)}</span>,
    },
    {
      title: "Paid Amount",
      key: "6",
      dataIndex: "paidAmount",
      render: (text) => <span>{text?.toFixed(2)}</span>,
    },
    {
      title: "Balance",
      key: "7",
      dataIndex: "balance",
      render: (text) => <span>{text?.toFixed(2)}</span>,
    },
    { title: "Ageing (Days)", key: "8", dataIndex: "ageing" },
    { title: "Credit Period (Days)", key: "9", dataIndex: "creditPeriod" },
  ];

  useEffect(() => {
    const initialSelectedColumns = menuItems
      .filter((item) => item.checked)
      .map((item) => columns.find((col) => col.key === item.value));
    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns.find((col) => col.key === columnKey),
        ];
        return updatedColumns.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };

  const modifiedList = reportData?.filter(
    (obj) =>
      obj?.vendorName?.toLowerCase().includes(searchText.toLowerCase()) ||
      obj?.billNo?.toLowerCase().includes(searchText.toLowerCase())
  );

  const footerTotals = {
    billAmount: reportData?.reduce((sum, r) => sum + r.billAmount, 0)?.toFixed(2) ?? "0.00",
    paidAmount: reportData?.reduce((sum, r) => sum + r.paidAmount, 0)?.toFixed(2) ?? "0.00",
    balance: reportData?.reduce((sum, r) => sum + r.balance, 0)?.toFixed(2) ?? "0.00",
  };

  const getActiveTabData = () => {
    const fieldMapping = {};
    columns.forEach((col) => {
      fieldMapping[col.title] = col.dataIndex;
    });
    return { data: modifiedList, columns: selectedColumns, fieldMapping, Rname: "Payable Report" };
  };

  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Payable Report</h4>
                <h6>Manage Payable Report here</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() => exportreportPDF(getActiveTabData, footerTotals)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Excel")}>
                  <button
                    onClick={() => exportreportExcel(getActiveTabData, footerTotals)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath src="assets/img/icons/excel.svg" alt="excel-icon" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Print")}>
                  <button
                    onClick={() => printreportReport(getActiveTabData)}
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("Collapse")}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div id="DataTables_Table_0_filter" className="dataTables_filter">
                      <label>
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <div className="input-blocks me-2">
                    <button
                      className="btn btn-filters rounded-2 h-100"
                      onClick={() => {
                        setCurrentPage(1);
                        setPageSize(20);
                        fetchReport();
                      }}
                    >
                      <i data-feather="search" className="feather-search" /> Search
                    </button>
                  </div>
                  <div className="input-blocks">
                    <button className="btn btn-reset rounded-2" onClick={handleReset}>
                      <i data-feather="refresh-cw" className="feather-refresh-cw" /> Reset
                    </button>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`}
                    onClick={toggleFilterVisibility}
                    id="filter_search"
                  >
                    <Filter className="filter-icon" />
                    <span>
                      <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                    </span>
                  </Link>
                </div>
                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems.map((obj, i) => (
                      <li key={i}>
                        <Checkbox
                          onChange={(e) => handleCheckboxChange(obj.value, e.target.checked)}
                          defaultChecked={obj.checked}
                        >
                          <div style={{ color: "black" }}>{obj.label}</div>
                        </Checkbox>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label>As of Date</label>
                        <div className="input-groupicon calender-input">
                          <Calendar className="info-img" />
                          <DatePicker
                            className="datetimepicker"
                            value={asOfDate}
                            onChange={(date) => setAsOfDate(date)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label>Vendor</label>
                        <Select
                          options={supplierOptions}
                          value={selectedSupplier}
                          onChange={setSelectedSupplier}
                          placeholder="All Vendors"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label>Ageing Period</label>
                        <Select
                          options={ageingOptions}
                          value={selectedAgeingPeriod}
                          onChange={setSelectedAgeingPeriod}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label>Credit Period</label>
                        <Select
                          options={creditPeriodOptions}
                          value={selectedCreditPeriod}
                          onChange={setSelectedCreditPeriod}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    columns={selectedColumns}
                    dataSource={modifiedList}
                    ref={tableRef}
                    id="table-to-export"
                    className="table datanew dataTable no-footer custom-table"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                    }}
                    summary={() => (
                      <Table.Summary.Row>
                        {selectedColumns?.map((col) => (
                          <Table.Summary.Cell key={col.dataIndex}>
                            <b>{footerTotals[col.dataIndex] || ""}</b>
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>
                    )}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayableReport;
